import { baseComponentApi } from 'app/src/services/welfareportal'
import { useWebAppContext } from 'app/src/shared/hooks'
import { Button } from 'primereact/button'
import { useTranslation } from 'react-i18next'

export function ReadableAttachmentList(props: {
  title: string
  attachments: baseComponentApi.AttachmentBase[]
  onAttachmentRead?: (attachmentId: string, attachmentName: string) => void
}) {
  const context = useWebAppContext()
  const tErr = useTranslation('errors')

  const { title, attachments, onAttachmentRead } = props

  const handleAttachmentClick = async (attach: baseComponentApi.AttachmentBase): Promise<boolean> => {
    if (!attach.resourceLink) {
      return false
    }

    try {
      const response = await fetch(attach.resourceLink, { method: 'HEAD' })
      const contentType = response.headers.get('content-type') ?? ''

      if (contentType.toLowerCase().includes('pdf')) {
        // Apre il documento in una nuova finestra/tab
        window.open(attach.resourceLink, '_blank', 'noopener,noreferrer')

        // Scatena la callback se fornita
        onAttachmentRead?.(attach.id!, attach.name!)

        return true
      }

      errorMessage()
      return false
    } catch {
      errorMessage()
      return false
    }
  }

  const errorMessage = () => {
    // Se c'è un errore nell'apertura del link, mostra un messaggio di errore
    context.showToastMessage({
      severity: 'error',
      summary: tErr.t('DownloadFileErrorMessage') || "Errore nell'apertura del documento",
    })
  }

  return (
    <div className='grid grid-cols-12'>
      <p className='col-span-11 col-start-1 my-[8px] text-[16px] font-semibold leading-[24px] text-[#4A4A4A] md:col-span-11 md:col-start-1'>
        {title}
      </p>
      {attachments.map((attach) => (
        <div key={attach.id} className='col-span-11 col-start-1'>
          <Button
            data-testid={`attachment-element`}
            label={attach.name}
            text
            className='my-[2px] p-0 text-left'
            icon={context.portalConfiguration.iconPdfSrc}
            iconPos='left'
            pt={{ label: { className: 'text-[16px] font-semibold leading-[24px]' }, icon: { className: 'text-[16px]' } }}
            onClick={() => handleAttachmentClick(attach)}
          />
        </div>
      ))}
    </div>
  )
}
